import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import Deposit from '../components/dashboard/Deposit';
import Loader from '../components/Loader';
import Funding from '../components/stocks/Funding';

function FxtDeposit({ user }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [walletAddress, setWalletAddress] = useState({});

  useEffect(() => {
    const fetchWalletData = async () => {
      try {
        const docRef = doc(db, 'shipments', 'wallets');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setWalletAddress(docSnap.data());
        }
      } catch (error) {
        console.error("Error fetching wallet data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletData();
  }, []);

  const handleCloseModal = () => {
    navigate('/fxt');
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="skyfxt-box fxt-deposit">
      
      <Deposit
        loading={loading}
        walletAddress={walletAddress}
        handleCloseModal={handleCloseModal}
        user={user}
      />
      <Funding />
    </div>
  );
}

export default FxtDeposit;